export default __webpack_public_path__ + "media/metronic/_theme/media/misc/bg-2-f0d4ef36d0486c4f6175239baee1032e.jpg";